import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { NgbModule, NgbPopoverModule } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { I18nModule } from "@spartacus/core";
import { PaymentMethodComponent } from "./payment-method.component";


@NgModule({
  declarations: [PaymentMethodComponent],
  exports: [PaymentMethodComponent],
  imports: [
    CommonModule,
    NgSelectModule,
    I18nModule,
    FormsModule,
    BrowserModule,
    NgbModule,
    NgbPopoverModule
  ],
  providers: [
  ],
})
export class PaymentMethodModule { }
